<script lang="ts" >
import Component from 'vue-class-component'
import AdminList from '@/components/admin/AdminList.vue'
import { AloPositionRemarquable } from '@/models/alo/AloPositionRemarquable'

@Component({
  name: 'AdminPositionRemarquableList'
})

export default class AdminPositionRemarquableList extends AdminList<AloPositionRemarquable> {  
 
  get itemTypeName() {
    return "PositionRemarquable"
  }

}
</script>